export { MediaPage as default } from '@/components/enpages/Contact/Media'
